import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext';

export default function ClientPrivateRoute( { children }) {
    const { currentUser } = useAuth();
    const location = useLocation();
    return currentUser?.client ? children : <Navigate to="/client-login" state={{from: location}} />;
}